module.exports = __webpack_public_path__ + "ecd791f27df047aca6dd8848051e1183.svg";